module.exports = __webpack_public_path__ + "static/media/festival_04.cdff9a78.jpg";